(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeTrackingButton', PropriedadeTrackingButton);

  function PropriedadeTrackingButton() {
    return {
      restrict: 'E',
      scope: {
        gleba: '<'
      },
      controller: 'TrackingPropriedadeCtrl',
      templateUrl: 'views/directives/propriedade-tracking-button.html'
    };
  }
}());
